// src/components/BotSettings/BotSettingsHeader.js
// @flow

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

import HeaderTopBar from '../HeaderTopBar';
import AppLoadingSpinner from '../SharedComponents/AppLoadingSpinner';

import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';
import { useI18n } from '../../contexts/I18nContext';
// If you need data from Redux, import your selectors & actions, e.g.:
// import { selectSomething } from '../../reduxStore/modules/botSettings';

type Props = {
  mobileOpen: boolean,
  usehandleDrawerToggle: Function
};

const BotSettingsHeader = (props: Props) => {
  const { mobileOpen, usehandleDrawerToggle } = props;

  const theme = useTheme();
  const i18n = useI18n();
  const dispatch = useDispatch();

  // Example usage of a hypothetical Redux store for bot settings:
  // const botSomething = useSelector(selectSomething);

  // If you previously used `useStore()` or a custom hook to get i18n or something, now we do:
  // const { i18n } = store; (replaced by useI18n() above)

  // Any state that's purely local to the header:
  const [anyLocalState, setAnyLocalState] = useState(null);

  return (
    <AppBar sx={memberHeaderStyles.appBar(theme)} position="fixed">
      <Toolbar sx={memberHeaderStyles.toolbar(theme)} disableGutters>
        <Grid container direction='column'>
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography variant='h2' sx={memberHeaderStyles.pageTitle(theme)}>
              {i18n.t('Neo the bot')}
            </Typography>
          </HeaderTopBar>

          <Grid
            item
            sx={{...memberHeaderStyles.rowSub(theme), ...memberHeaderStyles.bottomBar(theme)}}
          >
            <Box 
              sx={memberHeaderStyles.toggleContainer(theme)}
            >
            </Box>
          </Grid>
          <AppLoadingSpinner />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default BotSettingsHeader;